module.exports = __webpack_public_path__ + "img/mvp.ba1de550.png";